(function () {
  'use strict';

  const ROOT_SELECTOR = '[data-fsbs-root]';
  const INITIALIZED_ATTR = 'data-fsbs-initialized';

  function getSite() {
    const currentDomain = window.location.hostname;

    switch (currentDomain) {
      case 'uk.renogy.com':
        return { site: 'UK', apiUrl: 'https://shopify-api.renogy.com' };
      case 'www.renogy.com':
        return { site: 'US', apiUrl: 'https://shopify-api.renogy.com' };
      case 'ca.renogy.com':
        return { site: 'CA', apiUrl: 'https://shopify-api.renogy.com' };
      case 'au.renogy.com':
        return { site: 'AU', apiUrl: 'https://shopify-api.renogy.com' };
      case 'de.renogy.com':
        return { site: 'DE', apiUrl: 'https://shopify-api.renogy.com' };
      case 'eu.renogy.com':
        return { site: 'EU', apiUrl: 'https://shopify-api.renogy.com' };
      case 'jp.renogy.com':
        return { site: 'JP', apiUrl: 'https://shopify-api.renogy.com' };
      case 'nl.renogy.com':
        return { site: 'NL', apiUrl: 'https://shopify-api.renogy.com' };
      case 'it.renogy.com':
        return { site: 'IT', apiUrl: 'https://shopify-api.renogy.com' };
      case 'es.renogy.com':
        return { site: 'ES', apiUrl: 'https://shopify-api.renogy.com' };
      case 'za.renogy.com':
        return { site: 'ZA', apiUrl: 'https://shopify-api.renogy.com' };
      case 'fr.renogy.com':
        return { site: 'FR', apiUrl: 'https://shopify-api.renogy.com' };
      default:
        return { site: 'RenogyTest', apiUrl: 'https://d-shopify-api.renogy.cn' };
    }
  }

  function normalizeTime(timeString) {
    if (!timeString) return '';
    return timeString.toString().replace(/["',]/g, '').trim();
  }

  function parseTime(timeString) {
    const normalized = normalizeTime(timeString);
    if (!normalized) return null;

    const timestamp = new Date(normalized).getTime();
    return Number.isNaN(timestamp) ? null : timestamp;
  }

  function padNumber(value) {
    return value < 10 ? `0${value}` : String(value);
  }

  function getCardState(card) {
    const now = Date.now();
    const startTime = parseTime(card.dataset.startTime);
    const endTime = parseTime(card.dataset.endTime);

    if (endTime && now > endTime) {
      return 'ended';
    }

    if (startTime && now >= startTime) {
      return 'active';
    }

    // 与 Liquid 一致：未配置开始时间，或开始时间未到 → before
    return 'before';
  }

  function getTemplateText(template) {
    if (!template) return '';
    return (template.content?.textContent || template.textContent || '').trim();
  }

  function getTemplateHtml(template) {
    if (!template) return '';
    if (template.content?.childNodes?.length) {
      const wrapper = document.createElement('div');
      wrapper.appendChild(template.content.cloneNode(true));
      return wrapper.innerHTML.trim();
    }
    return (template.innerHTML || '').trim();
  }

  function getStateTargetTime(card, state) {
    if (state === 'before') return parseTime(card.dataset.startTime);
    if (state === 'active') return parseTime(card.dataset.endTime);
    return null;
  }

  function updateText(element, value) {
    if (!element) return;
    element.textContent = value;
  }

  function isMobileDevice() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  class FlashSaleBannerSlider {
    constructor(root) {
      this.root = root;
      this.slider = root.querySelector('[data-fsbs-slider]');
      this.carousel = root.querySelector('.fsbs-carousel');
      this.prevButton = root.querySelector('[data-fsbs-prev]');
      this.nextButton = root.querySelector('[data-fsbs-next]');
      this.scrollbar = root.querySelector('[data-fsbs-scrollbar]');
      this.scrollbarHandle = root.querySelector('[data-fsbs-scrollbar-handle]');
      this.scrollbarTrack = root.querySelector('.fsbs-scrollbar-track');
      this.sectionId = root.dataset.sectionId || '';
      this.successMessage = root.dataset.successMessage || "You're in! We'll remind you.";
      this.errorMessage = root.dataset.errorMessage || 'Subscription failed. Please try again.';
      this.cardIntervals = new Map();
      this.reminderSuccessTimeouts = new WeakMap();
      this.currentMobileToggle = null;
      this.mobileKeyboardHandled = false;
    }

    init() {
      if (!this.root || this.root.getAttribute(INITIALIZED_ATTR) === 'true') return;
      this.root.setAttribute(INITIALIZED_ATTR, 'true');

      this.bindSlider();
      this.initCards();
      this.bindCountdownLayout();
      this.bindReminderEvents();
    }

    bindSlider() {
      if (!this.slider) return;

      const updateBtnPosition = () => {
        if (!this.prevButton || !this.nextButton) return;
        if (window.matchMedia('(max-width: 768px)').matches) return;

        const item = this.slider.querySelector('[data-fsbs-card]');
        if (!item) return;

        const container = this.carousel;
        if (!container) return;

        const containerRect = container.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const cardCenter = itemRect.top - containerRect.top + itemRect.height / 2;

        [this.prevButton, this.nextButton].forEach((button) => {
          button.style.top = `${cardCenter}px`;
          button.style.transform = 'translateY(-50%)';
        });
      };

      const updateEdgeState = () => {
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        const max = this.slider.scrollWidth - this.slider.clientWidth;
        const cardCount = this.slider.querySelectorAll('[data-fsbs-card]').length;
        const visibleCapacity = isMobile
          ? 2
          : window.matchMedia('(max-width: 1023px)').matches
            ? 3
            : window.matchMedia('(max-width: 1279px)').matches
              ? 4
              : 5;
        const hasScroll = max > 1 || cardCount > visibleCapacity;
        const atStart = this.slider.scrollLeft <= 1;
        const atEnd = this.slider.scrollLeft >= max - 1;

        if (this.prevButton) {
          this.prevButton.style.display = !isMobile && hasScroll && !atStart ? 'flex' : 'none';
        }

        if (this.nextButton) {
          this.nextButton.style.display = !isMobile && hasScroll && !atEnd ? 'flex' : 'none';
        }

        this.updateScrollbar(hasScroll, max);
      };

      const getScrollAmount = () => {
        const item = this.slider.querySelector('[data-fsbs-card]');
        if (!item) return this.slider.clientWidth;
        const gap = parseFloat(window.getComputedStyle(this.slider).columnGap || '0') || 0;
        return item.offsetWidth + gap;
      };

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.slider.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.slider.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
      }

      const refreshSliderUi = () => {
        updateEdgeState();
        updateBtnPosition();
      };

      this.slider.addEventListener('scroll', refreshSliderUi, { passive: true });
      window.addEventListener('resize', refreshSliderUi);
      this.slider.querySelectorAll('img').forEach((image) => {
        if (image.complete) return;
        image.addEventListener('load', refreshSliderUi, { once: true });
      });
      requestAnimationFrame(refreshSliderUi);
      setTimeout(refreshSliderUi, 100);
      setTimeout(refreshSliderUi, 200);
      setTimeout(refreshSliderUi, 500);
      setTimeout(refreshSliderUi, 1000);
    }

    updateScrollbar(hasScroll, maxScroll) {
      if (!this.scrollbar || !this.scrollbarHandle) return;

      this.scrollbar.classList.toggle('is-visible', hasScroll);
      if (!hasScroll) {
        this.scrollbarHandle.style.width = '100%';
        this.scrollbarHandle.style.transform = 'translateX(0)';
        return;
      }

      const trackWidth = this.scrollbarTrack?.clientWidth || this.scrollbar.clientWidth;
      if (!trackWidth) return;

      const visibleRatio = this.slider.clientWidth / this.slider.scrollWidth;
      const handleWidth = Math.max(36, trackWidth * visibleRatio);
      const progress = maxScroll > 0 ? this.slider.scrollLeft / maxScroll : 0;
      const translateX = (trackWidth - handleWidth) * progress;

      this.scrollbarHandle.style.width = `${handleWidth}px`;
      this.scrollbarHandle.style.transform = `translateX(${translateX}px)`;
    }

    initCards() {
      this.root.querySelectorAll('[data-fsbs-card]').forEach((card) => {
        this.updateCardState(card);
        this.startCardCountdown(card);
      });
    }

    updateCountdownLayout(countdown) {
      if (!countdown || countdown.hidden) return;

      if (countdown.classList.contains('fsbs-countdown--ended')) {
        countdown.classList.remove('is-overflowing');
        return;
      }

      const overflows = countdown.scrollWidth > countdown.clientWidth + 1;
      countdown.classList.toggle('is-overflowing', overflows);
    }

    bindCountdownLayout() {
      const countdowns = this.root.querySelectorAll('[data-fsbs-countdown]');
      if (!countdowns.length) return;

      const refreshAll = () => {
        countdowns.forEach((countdown) => this.updateCountdownLayout(countdown));
      };

      if (typeof ResizeObserver !== 'undefined') {
        this.countdownResizeObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => this.updateCountdownLayout(entry.target));
        });
        countdowns.forEach((countdown) => this.countdownResizeObserver.observe(countdown));
      }

      window.addEventListener('resize', refreshAll);
      requestAnimationFrame(refreshAll);
      setTimeout(refreshAll, 100);
    }

    updateCardState(card) {
      const state = getCardState(card);
      if (card.dataset.state !== state) {
        card.classList.remove(`fsbs-card--${card.dataset.state}`);
      }

      card.dataset.state = state;
      card.classList.add(`fsbs-card--${state}`);
      this.updateCardMedia(card, state);
      this.updateCardCopy(card, state);
      this.updateReminderVisibility(card, state);
      this.updateCountdownLabel(card, state);
    }

    updateCardMedia(card, state) {
      const link = card.querySelector('[data-fsbs-card-link]');
      const image = card.querySelector('[data-fsbs-card-image]');
      const nextUrl = card.dataset[`${state}Url`] || '#';
      const nextImage = card.dataset[`${state}Image`];

      if (link) {
        link.href = nextUrl || '#';
      }

      if (image && nextImage && image.src !== nextImage) {
        image.src = nextImage;
      }
    }

    shouldKeepCopyVisibleForReminder(copy) {
      const reminder = copy?.querySelector('[data-fsbs-reminder]');
      if (!reminder || reminder.hidden) return false;

      const success = reminder.querySelector('[data-fsbs-reminder-success]');
      if (success && !success.hidden) return true;

      const form = reminder.querySelector('[data-fsbs-reminder-form]');
      if (form && !form.hidden) {
        if (!isMobileDevice()) return true;
        if (form.classList.contains('is-open')) return true;
      }

      const toggle = reminder.querySelector('[data-fsbs-reminder-toggle]');
      if (toggle && !toggle.hidden) return true;

      return false;
    }

    updateCardCopy(card, state) {
      const copy = card.querySelector('[data-fsbs-card-copy]');
      if (!copy) return;

      const titleEl = card.querySelector('[data-fsbs-card-title]');
      const subtitleEl = card.querySelector('[data-fsbs-card-subtitle]');
      let title = '';
      let subtitle = '';

      if (titleEl && subtitleEl) {
        const titleTemplate = card.querySelector(`template[data-fsbs-title="${state}"]`);
        const subtitleTemplate = card.querySelector(`template[data-fsbs-subtitle="${state}"]`);
        const nextUrl = card.dataset[`${state}Url`] || '#';
        title = getTemplateText(titleTemplate);
        subtitle = getTemplateHtml(subtitleTemplate);

        titleEl.textContent = title;
        titleEl.href = nextUrl || '#';
        titleEl.hidden = !title;

        subtitleEl.innerHTML = subtitle;
        subtitleEl.hidden = !subtitle;

        const mediaLink = card.querySelector('[data-fsbs-card-link]');
        if (mediaLink) {
          mediaLink.href = nextUrl || '#';
          if (title) {
            mediaLink.setAttribute('aria-label', title);
          }
        }
      }

      copy.hidden = !(title || subtitle) && !this.shouldKeepCopyVisibleForReminder(copy);
    }

    updateReminderVisibility(card, state) {
      const reminder = card.querySelector('[data-fsbs-reminder]');
      if (!reminder) return;

      reminder.hidden = state !== 'before';
    }

    updateCountdownStateColors(countdown, state) {
      if (!countdown || state === 'ended') return;

      const stripBg = countdown.dataset[`${state}StripBg`];
      const numberBg = countdown.dataset[`${state}NumberBg`];

      if (stripBg) {
        countdown.style.setProperty('--fsbs-countdown-bg-color', stripBg);
      }

      if (numberBg) {
        countdown.style.setProperty('--fsbs-countdown-number-bg', numberBg);
        countdown.style.setProperty('--fsbs-countdown-text-color', numberBg);
      }
    }

    updateCountdownLabel(card, state) {
      const countdown = card.querySelector('[data-fsbs-countdown]');
      if (!countdown) return;

      const label = countdown.querySelector('[data-fsbs-countdown-label]');
      const values = countdown.querySelector('.fsbs-countdown-values');
      const endedText = countdown.dataset.endedText || '';

      this.updateCountdownStateColors(countdown, state);

      if (state === 'ended') {
        countdown.classList.add('fsbs-countdown--ended');
        updateText(label, endedText);
        if (values) values.hidden = true;
        countdown.hidden = !endedText;
        this.updateCountdownLayout(countdown);
        return;
      }

      countdown.classList.remove('fsbs-countdown--ended');
      const text = countdown.dataset[`${state}Text`] || '';
      const targetTime = getStateTargetTime(card, state);

      updateText(label, text);
      if (values) values.hidden = false;
      countdown.hidden = !targetTime;
      this.updateCountdownLayout(countdown);
    }

    startCardCountdown(card) {
      const cardId = card.dataset.cardId;
      if (!cardId) return;

      if (this.cardIntervals.has(cardId)) {
        clearInterval(this.cardIntervals.get(cardId));
      }

      const tick = () => {
        this.updateCardState(card);

        const state = card.dataset.state;
        const countdown = card.querySelector('[data-fsbs-countdown]');

        if (!countdown) return;

        if (state === 'ended') {
          this.updateCountdownLabel(card, state);
          return;
        }

        const targetTime = getStateTargetTime(card, state);

        if (!targetTime) {
          countdown.hidden = true;
          return;
        }

        const timeLeft = Math.max(0, targetTime - Date.now());

        if (timeLeft <= 0) {
          this.updateCardState(card);
          return;
        }

        const days = Math.floor(timeLeft / 86400000);
        const hours = Math.floor((timeLeft % 86400000) / 3600000);
        const minutes = Math.floor((timeLeft % 3600000) / 60000);
        const seconds = Math.floor((timeLeft % 60000) / 1000);

        updateText(countdown.querySelector('[data-fsbs-countdown-day]'), padNumber(days));
        updateText(countdown.querySelector('[data-fsbs-countdown-hour]'), padNumber(hours));
        updateText(countdown.querySelector('[data-fsbs-countdown-minute]'), padNumber(minutes));
        updateText(countdown.querySelector('[data-fsbs-countdown-second]'), padNumber(seconds));
        this.updateCountdownLayout(countdown);
      };

      tick();
      this.cardIntervals.set(cardId, setInterval(tick, 1000));
    }

    bindReminderEvents() {
      this.ensureMobileKeyboardOverlay();

      this.root.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-fsbs-reminder-toggle]');
        if (!toggle || !this.root.contains(toggle)) return;

        event.preventDefault();

        if (isMobileDevice()) {
          this.openMobileKeyboardForm(toggle);
          return;
        }

        const reminder = toggle.closest('[data-fsbs-reminder]');
        const form = reminder?.querySelector('[data-fsbs-reminder-form]');
        const input = form?.querySelector('input[type="email"]');
        if (!form) return;

        form.hidden = false;
        form.classList.add('is-open');
        toggle.hidden = true;
        if (input) {
          input.focus();
        }
      });

      this.root.addEventListener('input', (event) => {
        const input = event.target.closest('[data-fsbs-reminder-form] input[type="email"]');
        if (!input || !this.root.contains(input)) return;

        const form = input.closest('[data-fsbs-reminder-form]');
        const submitButton = form?.querySelector('.fsbs-submit');
        if (!submitButton) return;

        if (input.value.trim()) {
          submitButton.removeAttribute('disabled');
        } else {
          submitButton.setAttribute('disabled', 'disabled');
        }
      });

      this.root.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-fsbs-reminder-form]');
        if (!form || !this.root.contains(form)) return;

        event.preventDefault();
        this.submitReminderForm(form);
      });

      this.bindMobileKeyboardEvents();
    }

    ensureMobileKeyboardOverlay() {
      if (this.mobileKeyboardOverlay) return;

      this.mobileKeyboardOverlay = document.querySelector(
        `[data-fsbs-keyboard-overlay][data-fsbs-section-id="${this.sectionId}"]`
      );
      if (!this.mobileKeyboardOverlay) return;

      this.mobileKeyboardForm = this.mobileKeyboardOverlay.querySelector('[data-fsbs-keyboard-form]');
      this.mobileKeyboardInput = this.mobileKeyboardOverlay.querySelector('[data-fsbs-keyboard-input]');
      this.mobileKeyboardSubmit = this.mobileKeyboardOverlay.querySelector('[data-fsbs-keyboard-submit]');
      this.mobileKeyboardContainer = this.mobileKeyboardOverlay.querySelector('.fsbs-keyboard-form-container');
    }

    bindMobileKeyboardEvents() {
      if (!this.mobileKeyboardOverlay || this.mobileKeyboardBound) return;
      this.mobileKeyboardBound = true;

      this.mobileKeyboardOverlay.addEventListener('click', (event) => {
        if (event.target === this.mobileKeyboardOverlay) {
          this.hideMobileKeyboardForm();
        }
      });

      this.mobileKeyboardContainer?.addEventListener('click', (event) => {
        event.stopPropagation();
      });

      this.mobileKeyboardInput?.addEventListener('input', () => {
        if (!this.mobileKeyboardSubmit) return;
        if (this.mobileKeyboardInput.value.trim()) {
          this.mobileKeyboardSubmit.removeAttribute('disabled');
        } else {
          this.mobileKeyboardSubmit.setAttribute('disabled', 'disabled');
        }
      });

      this.mobileKeyboardForm?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!this.mobileKeyboardInput || !this.mobileKeyboardSubmit || !this.currentMobileToggle) return;

        const card = this.currentMobileToggle.closest('[data-fsbs-card]');
        const inlineForm = card?.querySelector('[data-fsbs-reminder-form]');
        if (!inlineForm) return;

        const email = this.mobileKeyboardInput.value.trim();
        if (!email) return;

        this.mobileKeyboardSubmit.setAttribute('disabled', 'disabled');
        this.mobileKeyboardInput.setAttribute('disabled', 'disabled');

        inlineForm.querySelector('input[type="email"]').value = email;

        try {
          await this.submitReminderForm(inlineForm, {
            skipFinallyReset: true,
            onSuccess: () => {
              this.hideMobileKeyboardForm();
              this.showReminderSuccess(inlineForm);
            },
          });
        } finally {
          this.mobileKeyboardInput.removeAttribute('disabled');
          this.mobileKeyboardSubmit.removeAttribute('disabled');
        }
      });
    }

    openMobileKeyboardForm(toggle) {
      this.ensureMobileKeyboardOverlay();

      const card = toggle.closest('[data-fsbs-card]');
      const inlineForm = card?.querySelector('[data-fsbs-reminder-form]');
      const inlineInput = inlineForm?.querySelector('input[type="email"]');
      const inlineSubmit = inlineForm?.querySelector('.fsbs-submit');
      if (!this.mobileKeyboardOverlay || !this.mobileKeyboardInput || !this.mobileKeyboardSubmit) return;

      this.currentMobileToggle = toggle;
      this.mobileKeyboardHandled = true;

      const placeholder = inlineInput?.getAttribute('placeholder') || 'Enter Email for Reminder';
      const defaultButtonText =
        this.root.dataset.keyboardSubmitLabel?.trim() || 'Notify';
      const buttonText =
        inlineSubmit?.textContent?.trim() || toggle.textContent.trim() || defaultButtonText;

      this.mobileKeyboardInput.placeholder = placeholder;
      this.mobileKeyboardSubmit.textContent = buttonText;
      this.mobileKeyboardInput.value = '';
      this.mobileKeyboardSubmit.setAttribute('disabled', 'disabled');

      const overlay = this.mobileKeyboardOverlay;
      const formContainer = this.mobileKeyboardContainer;

      overlay.removeAttribute('hidden');
      overlay.classList.remove('is-visible');
      overlay.style.transition = 'none';

      if (formContainer) {
        formContainer.style.transform = '';
        formContainer.style.top = '';
        formContainer.style.bottom = '';
        formContainer.style.transition = 'none';
      }

      void overlay.offsetHeight;

      if (formContainer) {
        formContainer.style.top = 'auto';
        formContainer.style.bottom = '0';
        formContainer.style.transform = 'translateY(0)';
      }

      overlay.classList.add('is-visible');
      void overlay.offsetHeight;

      requestAnimationFrame(() => {
        overlay.style.transition = '';
      });

      this.mobileKeyboardInput.removeAttribute('disabled');
      this.mobileKeyboardInput.focus({ preventScroll: false });

      if (document.activeElement !== this.mobileKeyboardInput) {
        setTimeout(() => {
          this.mobileKeyboardInput?.focus({ preventScroll: false });
        }, 0);
      }

      this.bindMobileKeyboardPosition(formContainer);
    }

    bindMobileKeyboardPosition(formContainer) {
      if (!formContainer) return;

      if (formContainer._keyboardPositionUpdater) {
        if (formContainer._updateTimer) clearTimeout(formContainer._updateTimer);
        if (window.visualViewport) {
          window.visualViewport.removeEventListener('resize', formContainer._keyboardPositionUpdater);
          window.visualViewport.removeEventListener('scroll', formContainer._keyboardPositionUpdater);
        } else {
          window.removeEventListener('resize', formContainer._keyboardPositionUpdater);
        }
      }

      const savedInitialHeight = window.innerHeight;
      let lastTopPosition = null;
      let updateTimer = null;

      const updatePositionToKeyboard = () => {
        if (updateTimer) clearTimeout(updateTimer);

        updateTimer = setTimeout(() => {
          formContainer._updateTimer = updateTimer;

          if (window.visualViewport) {
            const viewportHeight = window.visualViewport.height;
            const viewportTop = window.visualViewport.offsetTop || 0;
            const heightDiff = savedInitialHeight - viewportHeight;

            if (heightDiff > 100) {
              const topPosition = viewportTop + viewportHeight;
              if (lastTopPosition !== topPosition) {
                formContainer.style.top = `${topPosition}px`;
                formContainer.style.bottom = 'auto';
                formContainer.style.transform = 'translateY(-100%)';
                formContainer.style.transition = 'none';
                lastTopPosition = topPosition;
              }
            } else if (lastTopPosition !== null) {
              formContainer.style.top = 'auto';
              formContainer.style.bottom = '0';
              formContainer.style.transform = 'translateY(0)';
              formContainer.style.transition = 'none';
              lastTopPosition = null;
            }
            return;
          }

          const currentHeight = window.innerHeight;
          const heightDiff = savedInitialHeight - currentHeight;

          if (heightDiff > 100) {
            if (lastTopPosition !== currentHeight) {
              formContainer.style.top = `${currentHeight}px`;
              formContainer.style.bottom = 'auto';
              formContainer.style.transform = 'translateY(-100%)';
              formContainer.style.transition = 'none';
              lastTopPosition = currentHeight;
            }
          } else if (lastTopPosition !== null) {
            formContainer.style.top = 'auto';
            formContainer.style.bottom = '0';
            formContainer.style.transform = 'translateY(0)';
            formContainer.style.transition = 'none';
            lastTopPosition = null;
          }
        }, 50);
      };

      setTimeout(updatePositionToKeyboard, 100);
      setTimeout(updatePositionToKeyboard, 200);
      setTimeout(updatePositionToKeyboard, 300);

      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', updatePositionToKeyboard);
        window.visualViewport.addEventListener('scroll', updatePositionToKeyboard);
      } else {
        window.addEventListener('resize', updatePositionToKeyboard);
      }

      formContainer._keyboardPositionUpdater = updatePositionToKeyboard;
      formContainer._updateTimer = updateTimer;
    }

    hideMobileKeyboardForm() {
      if (!this.mobileKeyboardOverlay) return;

      const overlay = this.mobileKeyboardOverlay;
      const formContainer = this.mobileKeyboardContainer;

      if (formContainer?._keyboardPositionUpdater) {
        if (formContainer._updateTimer) clearTimeout(formContainer._updateTimer);
        if (window.visualViewport) {
          window.visualViewport.removeEventListener('resize', formContainer._keyboardPositionUpdater);
          window.visualViewport.removeEventListener('scroll', formContainer._keyboardPositionUpdater);
        } else {
          window.removeEventListener('resize', formContainer._keyboardPositionUpdater);
        }
        formContainer._keyboardPositionUpdater = null;
        formContainer._updateTimer = null;
      }

      overlay.classList.remove('is-visible');
      overlay.setAttribute('hidden', '');

      if (formContainer) {
        formContainer.style.top = '';
        formContainer.style.bottom = '';
        formContainer.style.transform = '';
        formContainer.style.transition = '';
      }

      if (this.mobileKeyboardInput) {
        this.mobileKeyboardInput.blur();
        this.mobileKeyboardInput.value = '';
        this.mobileKeyboardInput.removeAttribute('disabled');
      }

      if (this.mobileKeyboardSubmit) {
        this.mobileKeyboardSubmit.removeAttribute('disabled');
      }

      this.mobileKeyboardHandled = false;
      this.currentMobileToggle = null;
    }

    async submitReminderForm(form, options = {}) {
      const input = form.querySelector('input[type="email"]');
      const submitButton = form.querySelector('.fsbs-submit');
      if (!input || !submitButton) return;

      const email = input.value.trim();
      if (!email) return;

      submitButton.setAttribute('disabled', 'disabled');
      input.setAttribute('disabled', 'disabled');

      const isProduction = window.location.hostname.indexOf('renogy.com') > -1;
      const apiUrl = isProduction ? 'https://shopify-api.renogy.com' : 'https://d-shopify-api.renogy.cn';
      const currentDomain = isProduction ? window.location.hostname : 'shopify-uk.renogy.cn';
      const storeName = getSite().site;
      const tagName = form.closest('[data-fsbs-card]')?.dataset.tagName || '';
      const params = new URLSearchParams({
        Email: email,
        storeName,
      });

      if (tagName.trim()) {
        params.set('tagName', tagName.trim());
      }

      try {
        const response = await fetch(`${apiUrl}/api/shopify-client/subscript?${params.toString()}`, {
          method: 'GET',
          headers: {
            'X-Origin-Domain': currentDomain,
          },
        });
        const result = await response.json();

        if (result.code === 200) {
          if (typeof options.onSuccess === 'function') {
            options.onSuccess();
          } else {
            this.showReminderSuccess(form);
          }
          return;
        }

        this.showReminderError();
      } catch (error) {
        this.showReminderError();
      } finally {
        if (options.skipFinallyReset) return;
        input.removeAttribute('disabled');
        submitButton.removeAttribute('disabled');
      }
    }

    resetReminderState(reminder) {
      if (!reminder) return;

      const form = reminder.querySelector('[data-fsbs-reminder-form]');
      const success = reminder.querySelector('[data-fsbs-reminder-success]');
      const toggle = reminder.querySelector('[data-fsbs-reminder-toggle]');
      const input = form?.querySelector('input[type="email"]');
      const submitButton = form?.querySelector('.fsbs-submit');
      const isMobile = isMobileDevice();

      if (success) success.hidden = true;

      if (input) {
        input.value = '';
        input.removeAttribute('disabled');
      }

      if (submitButton) {
        submitButton.setAttribute('disabled', 'disabled');
      }

      if (form) {
        form.hidden = false;
        form.classList.remove('is-open');
      }

      if (toggle) {
        toggle.hidden = !isMobile;
      }
    }

    showReminderSuccess(form) {
      const reminder = form.closest('[data-fsbs-reminder]');
      const success = reminder?.querySelector('[data-fsbs-reminder-success]');
      const toggle = reminder?.querySelector('[data-fsbs-reminder-toggle]');

      form.hidden = true;
      form.classList.remove('is-open');
      if (toggle) toggle.hidden = true;
      if (success) {
        const text = success.querySelector('span');
        if (text) text.textContent = this.successMessage;
        success.hidden = false;
      }

      const existingTimeout = this.reminderSuccessTimeouts.get(reminder);
      if (existingTimeout) clearTimeout(existingTimeout);

      const timeoutId = setTimeout(() => {
        this.resetReminderState(reminder);
        this.reminderSuccessTimeouts.delete(reminder);
      }, 3000);

      this.reminderSuccessTimeouts.set(reminder, timeoutId);
    }

    showReminderError() {
      if (window.Swal) {
        window.Swal.fire({
          title: 'Failed!',
          text: this.errorMessage,
          icon: 'error',
          customClass: {
            popup: 'subscript-rg-dialog-popup',
          },
        });
      }
    }
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      new FlashSaleBannerSlider(root).init();
    });
  }

  window.FlashSaleBannerSlider = {
    init: initAll,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
